import { PropertyFilter } from '@src/v3/interfaces/utils/http';

const DEFAULT_FILTERS: PropertyFilter = {
  bathrooms: [],
  bedrooms: [],
  costMax: 50000,
  costMin: 0,
  estimatedCost: 0,
  isEasyApply: false,
  keyword: '',
  limit: 20,
  moveIn: '',
  offset: 0,
  squareFootageMax: 5000,
  squareFootageMin: 0,
  upfrontCost: 0,
  amenity: [],
  noFee: false,
  sortBy: '',
  sortLabel: '',
};

const BEDROOM_OPTIONS = [
  { key: '0', value: 'Studio' },
  { key: '1', value: '1' },
  { key: '2', value: '2' },
  { key: '3', value: '3' },
  { key: '4', value: '4+' },
];

const BATHROOM_OPTIONS = [
  { key: '1', value: '1' },
  { key: '1.5', value: '1.5' },
  { key: '2', value: '2' },
  { key: '2.5', value: '2.5' },
  { key: '3', value: '3+' },
];

const AMENITIES = [
  { key: 'parking', value: 'Parking' },
  { key: 'doorman', value: 'Doorman' },
  { key: 'gym', value: 'Gym' },
  { key: 'roof_deck', value: 'Roof Deck' },
  { key: 'elevator', value: 'Elevator Building' },
  { key: 'pool', value: 'Pool' },
  { key: 'dishwasher', value: 'In-Unit Dishwasher' },
  { key: 'laundry_mat', value: 'Laundromat' },
  { key: 'pet_friendly', value: 'Pet Friendly' },
  { key: 'in_unit_laundry', value: 'In-unit Laundry' },
  { key: 'balcony', value: 'Balcony' },
  { key: 'stainless_steel_appliances', value: 'Stainless Steel Appliances' },
];

export { AMENITIES, BATHROOM_OPTIONS, BEDROOM_OPTIONS, DEFAULT_FILTERS };
